import type { Settings } from "@instead/shared";
import { setLocale } from "./i18n.ts";

/** Applies §7.6 settings to <html> data-attributes — the single theming mechanism. */
export function applyAppearance(s: Settings): void {
  const el = document.documentElement;
  const sysDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const theme = s.appearance.theme === "system" ? (sysDark ? "dark" : "light") : s.appearance.theme;
  el.dataset["theme"] = theme;
  el.dataset["pack"] = s.appearance.pack;
  el.dataset["textsize"] = s.appearance.textSize === "system" ? "m" : s.appearance.textSize;
  el.dataset["density"] = s.appearance.density;
  if (s.appearance.highContrast) el.dataset["contrast"] = "high";
  else delete el.dataset["contrast"];
  if (s.appearance.motion === "reduced") el.dataset["motion"] = "reduced";
  else delete el.dataset["motion"];
  setLocale(s.locale);
}
